import { __require as e } from "../../../dompurify@3.2.6/bundled_deps/dompurify/dist/purify.cjs.js";
var r, i;
function o() {
  return i || (i = 1, r = window.DOMPurify || (window.DOMPurify = e().default || e())), r;
}
export {
  o as __require
};
